import axios from 'axios';

export default {
  getBlocks({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get('block', { useCache: true });
        commit('getBlocks', response.data.blocks);
        resolve();
      } catch (error) {
        console.warn(error);
        reject(error);
      }
    });
  },

  getFieldTypes({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get('block/types/', { useCache: true });

        commit('getFieldTypes', res.data.types);
        resolve();
      } catch (error) {
        console.warn(error);
        reject(error);
      }
    });
  },

  getType({ commit }, type) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get(`block/types/${type}`, { useCache: true });
        commit('getType', { [type]: response.data.type });
        resolve();
      } catch (error) {
        console.warn(error);
        reject(error);
      }
    });
  },

  /**
   * Saves the state of an editor module including content for filled fields and blocks.
   */
  saveEditorState({ commit }, data = null) {
    // Supported modules
    const supported = ['blog', 'news', 'page', 'press'];

    if (!supported.includes(data.module)) {
      return false;
    }
    // Check if the data object contains module name and if it is correct
    if (!supported.includes(data.module) || !data || !data.module || !data.data) {
      return false;
    }


    const parsedData = data.data;
    const parsedBlocks = JSON.stringify(data.blocks);

    // Assign meta data if empty
    parsedData.meta = parsedData.meta || {
      seo: {},
      og: {
        image: {},
      },
      canonical: '',
    };

    // Save only

    commit('saveEditorState', { module: data.module, data: parsedData, content: parsedBlocks });

    return true;
  },

  removeEditorState({ commit }, module) {
    const supported = ['blog', 'news', 'page', 'press'];
    // Check if the data object contains module name and if it is correct
    if (!supported.includes(module)) {
      return false;
    }

    commit('removeEditorState', module);

    return true;
  },
};
